import _ from "lodash";
import { checkFieldName, formatTimeString } from "../utils";
import parse from "html-react-parser";
import { format } from "date-fns";
import { Button } from "./Button";
import { Link } from "react-router-dom";

export const DisplayValue = ({
  name,
  value,
  model,
  className,
  type,
}: {
  name: string;
  model?: string;
  value: any;
  type?: string;
  className?: string;
}) => {
  const [displayName] = checkFieldName(name, model);
  return (
    <div className="flex text-sm font-medium">
      <div className="min-w-[12rem]">{displayName} :</div>
      {type === "image" ? (
        <div className="flex flex-col gap-2">
          <div className="opacity-30 text-sm">{value || "No image"}</div>
          {value && (
            <div className="w-full max-w-[16rem] space-y-2">
              <img src={value} />
            </div>
          )}
        </div>
      ) : type === "time" && value !== undefined ? (
        <div className={className}>{formatTimeString(value)}</div>
      ) : type === "wysiwyg" && value ? (
        <div className={className}>{parse(value)}</div>
      ) : type === "string_array" ? (
        <div className="flex flex-wrap gap-x-2 gap-y-1">
          {value && value.length > 0 ? (
            value.map((v: string, index: number) => (
              <span key={index} className="py-0.5 px-1 bg-grayBg">
                {v.replaceAll('"', "")}
              </span>
            ))
          ) : (
            <div className="opacity-50">None</div>
          )}
        </div>
      ) : type === "bool" ? (
        <div className={className}>{value === true ? "Yes" : "No"}</div>
      ) : type === "number" || value !== undefined ? (
        <div className={className}>{_.toString(value)}</div>
      ) : (
        <div className="opacity-30">Empty</div>
      )}
    </div>
  );
};
